import { type RouteObject, createBrowserRouter } from 'react-router-dom';
import App from '~/Components/App/App';
import BundlePurchase from '~/Components/BundlePurchase/BundlePurchase';

// Disable default scroll restoration
if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

// Routes
const routes: RouteObject[] = [
    {
        path: '/',
        element: <App />,
    },
    {
        path: '/:lang/bundlePurchase',
        element: <BundlePurchase />,
    },
];

const router = createBrowserRouter(routes as RouteObject[], { future: { v7_normalizeFormMethod: true } });

export type Router = typeof router;

export default router;
